export enum QualifiedEventName {
  ConversationStarted = 'Conversation Started',
  MeetingBooked = 'Meeting Booked',
  EmailCaptured = 'Email Captured',
}

export enum QualifiedMessengerEventName {
  MessagesDismissed = 'messagesDismissed',
  MessengerOpened = 'messengerOpened',
  MessengerClosed = 'messengerClosed',
}
